import { apiClient } from './api-client';

class GamesService {
  async getSpiele(params = {}) {
    try {
      const response = await apiClient.get('/spiele', { params })
      return response.data
    } catch {
      return []
    }
  }

  async getSpieleOrThrow(params = {}) {
    const response = await apiClient.get('/spiele', { params })
    return response.data
  }
}

export default new GamesService();
